// extracted by mini-css-extract-plugin
export default {"contentContainer":"styles_contentContainer__RYxRD","header":"styles_header__qsIcu","form":"styles_form__JuiKW"};